import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberUserManagementComponent } from './member-user-management.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiClient } from '../../core/api-client.service';


@NgModule({
  declarations: [
    MemberUserManagementComponent
  ],
  imports: [
    CommonModule
    , BrowserModule
    , FormsModule
    , ReactiveFormsModule
    , NgbPaginationModule
  ],
  providers: [ApiClient],
})
export class MemberUserManagementModule { }
